var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"event-period"},[(_vm.dates)?[_vm._v(" "+_vm._s(_vm.dates)+" ("+_vm._s(_vm.$t('events.event-details.local-time'))+") ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }